(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hue-review-section"]) return;
  try {
    
  document.addEventListener('hue-add-to-cart', async (e) => {
    const { detail } = e
    const { variantId } = detail
    const value = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(value),
    })

    const data = await response.json()

    if (response.ok) {
      document.dispatchEvent(new CustomEvent('cart-popup::open', { detail: data }))
      document.dispatchEvent(new CustomEvent('cart::add', { detail: data }))
      document.dispatchEvent(new CustomEvent('dlSDK::add_to_cart', { detail: data?.items[0] }))
    } else {
      throw new Error(data.description)
    }

    return data
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hidden"]) return;
  try {
    
  window.location.href = '/'

  } catch(e) { console.error(e); }
})();
})();
